import { Routes } from '@angular/router';
import {ViewComponent} from "./ui/view/view.component";
import {CacheService} from "./services/cache.service";
import {INFORMATION_PERSONAL, ROUTER_VIEW} from "./commons/constans";
import {PersonalDataFormComponent} from "./personal-data-form/personal-data-form.component";

export const routes: Routes = [
  { path: '', redirectTo: '', pathMatch: 'full' },
  {
    path: `${ROUTER_VIEW}/:id`,
    component: ViewComponent,
    providers:[
      CacheService
    ]
  },
  {
    path: `${INFORMATION_PERSONAL}`,
    component: PersonalDataFormComponent,
    providers:[
      CacheService
    ]
  }
];
